import NavigationBar from "../../components/navigationBar";
import ResearchExplainerComponent from "../../components/explainer-pages/researchExplainerComponent";
import FooterView from "../../components/footerView";


export default function ResearchExplainerPage() {



    return (
        <div>
            <NavigationBar />
            <ResearchExplainerComponent />
            <FooterView />
        </div>
    )
}